import React from 'react';

export interface LocationIconProps {
  size?: number | string;
  color?: string;
}

export function LocationIcon({ size = 16, color = 'currentColor' }: LocationIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.941406 7.10615C0.941406 3.3256 4.03165 0.235352 7.8122 0.235352C11.5927 0.235352 14.683 3.3256 14.683 7.10615C14.683 9.75645 12.9513 11.9224 11.3697 13.3616C10.5646 14.0943 9.76248 14.6715 9.16293 15.0652C8.86245 15.2625 8.61106 15.4149 8.43321 15.5188C8.34423 15.5708 8.27353 15.6107 8.22414 15.6382C8.19944 15.6519 8.18006 15.6625 8.16637 15.6699L8.15016 15.6786L8.14534 15.6812L8.14319 15.6824C8.14297 15.6825 8.14276 15.6826 7.8122 15.0589C7.51721 15.7002 7.51697 15.7001 7.51671 15.6999L7.51607 15.6996L7.51436 15.6989L7.50927 15.6965L7.49249 15.6886C7.47843 15.6819 7.45866 15.6725 7.43356 15.6602C7.38338 15.6358 7.31184 15.6001 7.22199 15.5535C7.0424 15.4602 6.78907 15.3226 6.4865 15.1416C5.88287 14.7804 5.07549 14.2418 4.26492 13.5326C2.66095 12.1291 0.941406 9.96348 0.941406 7.10615ZM7.8122 15.0589L7.51721 15.7002L7.83433 15.846L8.14276 15.6826L7.8122 15.0589ZM7.79181 14.2582C7.9455 14.167 8.14927 14.0419 8.38801 13.8851C8.94438 13.5198 9.68353 12.9872 10.4196 12.3174C11.9205 10.9516 13.2712 9.14117 13.2712 7.10615C13.2712 4.10529 10.8131 1.64712 7.8122 1.64712C4.81135 1.64712 2.35317 4.10529 2.35317 7.10615C2.35317 9.36568 3.71608 11.1764 5.19457 12.4701C5.92522 13.1094 6.65907 13.5996 7.21136 13.9301C7.44278 14.0686 7.64094 14.1782 7.79181 14.2582ZM8.10777 14.4179C8.10786 14.4179 8.10787 14.4179 8.10777 14.4179V14.4179Z"
        fill={color}
      />
      <path
        d="M6.33203 7.10604C6.33203 7.90748 7.01017 8.58562 7.81161 8.58562C8.61305 8.58562 9.29119 7.90748 9.29119 7.10604C9.29119 6.30461 8.61305 5.62646 7.81161 5.62646C7.01017 5.62646 6.33203 6.30461 6.33203 7.10604Z"
        fill={color}
      />
    </svg>
  );
}
